import React, { useRef, useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useRouteLoaderData, useLoaderData } from "react-router-dom";
import { axiosInstance } from "../../auth/Auth";

const FreestyleDeltasSelectionForm = ({
    setFreestyleDeltasData,
    demo,
    setDemo,
    collection,
    setCollection,
    displayLabels,
    selectedCollections,
    setSelectedCollections,
    index,
    handleRemove,
    refreshKey, // Adding refreshKey as a prop
}) => {
    const collectionTypeahead = useRef(null);
    const { radios, radiosModuleSettings, demographics } = useRouteLoaderData("root");
    const [radioNames, setRadioNames] = useState([]);
    const [demos, setDemos] = useState([]);
    const [freestyleDeltas, setFreestyleDeltas] = useState([]);

    useEffect(() => {
        if (collection?.[0]?.collection_id && !freestyleDeltas.some(fd => fd.collection_id === collection[0].collection_id)) {
            handleRemove(index);
        }
    }, [freestyleDeltas, collection, handleRemove, index]);

    useEffect(() => {
        async function fetchData() {
            try {
                const { data } = await axiosInstance.get("/freestyle_deltas/current_user/");
                setFreestyleDeltas(data);
            } catch (error) {
                console.error("Error fetching freestyle deltas:", error);
            }
        }

        fetchData();
    }, [refreshKey, selectedCollections]);

    useEffect(() => {
        async function getRadioNames() {
            const radiosData = (await radios).data;
            setRadioNames(
                radiosData.map(x => {
                    return { radio_id: x.radio_id, radio_name: x.radio_name };
                })
            );
        }
        if (radios) {
            getRadioNames();
        }
    }, [radios]);

    useEffect(() => {
        const station = collection?.[0]?.radio_id;

        async function getDemos(station) {
            if (!station) return false;
            const radio = (await radios).data.find(x => x.radio_id === station);
            const moduleSettings = (await radiosModuleSettings).data;
            const allDemos = (await demographics).data;
            const hasListenerGroupModule = moduleSettings.find(r => r.radio_id === station && r.module_id === 7 && r.enabled);
            const filteredDemos = allDemos.filter(
                x => (x.data_type === 1 && radio.stream && (hasListenerGroupModule ? true : x.listener_group === 0)) || (x.data_type === 2 && radio.ppm)
            );
            setDemos(filteredDemos);
        }

        if (station) {
            getDemos(station);
        } else {
            setDemos([]);
            setDemo([]);
        }
    }, [collection, demographics]);

    const getRadioName = radio_id => radioNames.find(x => x.radio_id === radio_id)?.radio_name || "";

    const handleStationChange = selected => {
        if (selected.length === 0) {
            handleRemove(index);
            return;
        }
        setCollection(selected);
        const updatedDemo = [...demo];
        const updatedSelectedCollections = [...selectedCollections];
        updatedSelectedCollections[index] = selected[0];
        setSelectedCollections(updatedSelectedCollections);
        setDemo(updatedDemo.filter(Boolean));
    };

    return (
        <Form className="row my-3">
            <Col xs={12} xl={10}>
                <Row>
                    <Form.Group controlId="freestyle-deltas-collection" as={Col} className="mb-3 mb-xl-0 col-12 col-xl-3">
                        {displayLabels && <Form.Label>Collection</Form.Label>}
                        <Typeahead
                            id="freestyle-deltas-collection-selection"
                            ref={collectionTypeahead}
                            options={freestyleDeltas.filter(option => {
                                if (!selectedCollections) return true;
                                return !selectedCollections.some(selected => selected?.collection_id === option?.collection_id);
                            })}
                            labelKey={option => `${option.collection_name} | ${getRadioName(option.radio_id)}`}
                            highlightOnlyResult
                            placeholder="Select collection..."
                            clearButton={true}
                            onClear={() => handleRemove()}
                            onChange={handleStationChange}
                            selected={collection}
                        />
                    </Form.Group>
                    <Form.Group controlId="freestyle-deltas-demo" as={Col} className="mb-3 mb-xl-0 col-12 col-xl-8">
                        {displayLabels && <Form.Label>Demographic(s)</Form.Label>}
                        <Typeahead
                            id="freestyle-deltas-demo-selection"
                            options={demos}
                            labelKey={x => `${x.data_type === 1 ? "Online" : "Cover"}: ${x.name}`}
                            onChange={value => {
                                setDemo(value);
                            }}
                            multiple
                            clearButton
                            disabled={!collection.length}
                            placeholder={!collection.length ? "Select collection first..." : "Select demographic"}
                            selected={demo ?? []}
                        />
                    </Form.Group>
                </Row>
            </Col>
        </Form>
    );
};

export default FreestyleDeltasSelectionForm;
